import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone, Star, Shield, Check } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
};

const staggerContainer = {
  animate: { transition: { staggerChildren: 0.1 } },
};

export const HeroSection = () => (
  <section className="relative min-h-[90vh] lg:min-h-screen flex items-center pt-20">
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage: `url(https://static.prod-images.emergentagent.com/jobs/80ea756f-7ea3-4803-b754-18b59043e07a/images/d9b70dc68cc964050d6b7582cabdba6cd06668dbb9ef9a403050982926bf0037.png)`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
    </div>

    <div className="container-max relative z-10 px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <motion.div
        className="max-w-2xl"
        initial="initial"
        animate="animate"
        variants={staggerContainer}
      >
        {/* Social proof pill */}
        <motion.div variants={fadeInUp} className="mb-6">
          <span className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white text-sm px-4 py-2">
            <span className="flex">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-[#FF5A1F] text-[#FF5A1F]" />
              ))}
            </span>
            <span className="font-medium">Rated 4.9/5 by 500+ customers</span>
          </span>
        </motion.div>

        <motion.h1
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-['Outfit'] font-black text-white tracking-tighter leading-[0.95] mb-5"
          variants={fadeInUp}
        >
          Professional Removals<br />
          in <span className="text-[#FF5A1F]">Cardiff</span> & Beyond
        </motion.h1>

        <motion.p
          className="text-base sm:text-lg md:text-xl text-white/90 max-w-lg mb-8 leading-relaxed"
          variants={fadeInUp}
        >
          Hitech Transit is a trusted removal company serving Cardiff, South Wales and England. Fully insured, transparent pricing, and a team that genuinely cares about your belongings.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-3 mb-8"
          variants={fadeInUp}
        >
          <Link
            to="/instant-quote"
            className="btn-primary inline-flex items-center justify-center gap-2 text-base sm:text-lg px-8 py-4"
            data-testid="hero-get-quote-btn"
          >
            Get Your Free Quote in 60s
            <ArrowRight className="w-5 h-5" />
          </Link>
          <a
            href="tel:07346209593"
            className="bg-white/10 backdrop-blur-sm text-white font-semibold px-6 py-4 inline-flex items-center justify-center gap-2 hover:bg-white/20 transition-colors border border-white/20"
            data-testid="hero-call-btn"
          >
            <Phone className="w-5 h-5" />
            07346 209593
          </a>
        </motion.div>

        {/* Micro trust signals */}
        <motion.div
          className="flex flex-wrap gap-x-6 gap-y-2"
          variants={fadeInUp}
        >
          {[
            "Free, no-obligation quote",
            "Fully insured to £50,000",
            "No hidden fees — ever",
          ].map((text) => (
            <span key={text} className="flex items-center gap-1.5 text-sm text-white/80">
              <Check className="w-4 h-4 text-[#FF5A1F]" />
              {text}
            </span>
          ))}
        </motion.div>
      </motion.div>
    </div>
  </section>
);
